// extracted by mini-css-extract-plugin
export var chevronIcon = "_ax-2";
export var teamName = "_ax-1";
export var teamSwitcherButton = "_ax-0";